import NavigationHeader from './components/navigationHeader';
import PageContainer from './components/pageContainer';
import PageFooter from './components/pageFooter';
import PageLayout from './components/pageLayout';
import PageBody from './components/pageBody';
import PageText from './components/pageText';
import { Link } from 'react-router-dom';
import { getGinghamClass } from '../useGinghamClass';

const updates = [
    {
        date: '3.25.26',
        items: [
            { headline: '★ NEW PRINTS & STICKERS ★', text: 'New art prints and sticker sheets have been added to the shop. Check them out~' },
        ],
    },
    {
        date: '3.23.26',
        items: [
            { headline: '★ SHOP IS OPEN ★', text: 'Press-on nails, stickers, prints, and more. Handmade by Joy.' },
            { headline: '★ COMMISSIONS OPEN ★', text: 'Custom commission slots are available. Get a set made just for you.' },
        ],
    },
    {
        date: '3.21.26',
        items: [
            { headline: '★ NEW SETS ★', text: 'New press-on nail designs have been added to the shop~ chrome, florals, fruits, and more.' },
        ],
    },
];

export const HomePage = () => {
    return (
        <PageLayout>
            <PageContainer>
                <PageBody>
                    <NavigationHeader />
                    <PageText>
                        <div className='homePageContent'>
                            <div className='updatesFeed'>
                                {updates.map((update, i) => (
                                    <div key={i} className='updateEntry'>
                                        <div className='updateDate'>{update.date}</div>
                                        <div className='updateBody'>
                                            {update.items.map((item, j) => (
                                                <div key={j} className='updateItem'>
                                                    <span className='updateHeadline'>{item.headline}</span>{' '}
                                                    <span className='updateText'>{item.text}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className='homeLinks'>
                                <Link to="/shop" className={`homeLinkBtn ${getGinghamClass('shop')}`}>shop →</Link>
                                <Link to="/shop/custom-commission" className={`homeLinkBtn ${getGinghamClass('commission')}`}>custom commission →</Link>
                            </div>
                        </div>
                    </PageText>
                    <PageFooter />
                </PageBody>
            </PageContainer>
        </PageLayout>
    );
};
